import { z } from 'zod';
import { GetMaterialQuoteResponseSchema } from './get-quote.ts';
import { BaseMaterialQuoteSchemaPartial, MaterialControlPropertiesSchema } from './material-quote.ts';

export const PatchMaterialQuoteUrlSchema = z.object({
    id: z.string().uuid(),
});

export const PatchMaterialQuoteRequestSchema = BaseMaterialQuoteSchemaPartial.and(
    MaterialControlPropertiesSchema.partial()
);

/**
 * validation schema for the response payload
 * we want to return the whole entity when PATCHing
 */
export const PatchMaterialQuoteResponseSchema = GetMaterialQuoteResponseSchema;

export type PatchMaterialQuoteRequest = z.infer<typeof PatchMaterialQuoteRequestSchema>;
export type PatchMaterialQuoteResponse = z.infer<typeof PatchMaterialQuoteResponseSchema>;
